// activeSamplingEvent/slice.js

import { activeSamplingEventInitialState } from "./activeSamplingEventState";
import { makeActiveSamplingEventActions } from "./activeSamplingEventActions";

// Mirror activeDelDrafts pattern: all form UI state lives under activeSamplingEvent
export const createActiveSamplingEventSlice = (set, get) => ({
  activeSamplingEvent: activeSamplingEventInitialState,
  activeSamplingEventActions: Object.freeze(
    makeActiveSamplingEventActions(set, get)
  ),
});
